import type { ReactElement } from "react";
import { Badge } from "@knowtex-ai/components";

export interface TelehealthToggleProps {
  isTelehealth: boolean;
  isReady: boolean;
  onToggle: () => void;
}

export default function TelehealthToggle({
  isTelehealth,
  isReady,
  onToggle,
}: TelehealthToggleProps): ReactElement {
  return (
    <div id="telehealth_setup" className="w-full max-w-[480px] mb-6 mx-auto">
      <label
        id="telehealth_setup_label"
        className="flex items-center gap-3 p-3 bg-white rounded-lg border border-gray-200 cursor-pointer hover:border-accent2 transition-colors"
      >
        <input
          id="telehealth_setup_checkbox"
          type="checkbox"
          checked={isTelehealth}
          onChange={onToggle}
          className="w-5 h-5 text-accent2 rounded focus:ring-accent2 cursor-pointer animate-pulse"
        />
        <div className="flex flex-col flex-1 min-w-0">
          <span className="text-base font-semibold text-dark-purple">Telehealth Visit</span>
          <span className="text-xs text-gray-600">
            Record both microphone and video call audio
          </span>
        </div>
        {isReady ? (
          <Badge variant="success" showIcon>
            Ready
          </Badge>
        ) : null}
      </label>
    </div>
  );
}
